import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { useConfiguration } from '../../context/configurationContext';
import { NamedRedirect } from '../../components';
import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import AboutCTAEnhancer from './AboutCTAEnhancer';
import ContactEnhancer from './ContactEnhancer';

// Hosted CMS pages that only exist to support the membership feature. When the
// membership feature is disabled (see configDefault.js), these are unreachable
// from the UI, so guard against direct navigation by redirecting to the landing page.
const MEMBERSHIP_PAGE_IDS = ['memberships', 'membership-terms'];

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const config = useConfiguration();
  const { params, pageAssetsData, inProgress, error } = props;
  const pageId = params.pageId || props.pageId;

  if (MEMBERSHIP_PAGE_IDS.includes(pageId) && !config.membership?.enabled) {
    return <NamedRedirect name="LandingPage" />;
  }

  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  return (
    <>
      <PageBuilder
        pageAssetsData={pageAssetsData?.[pageId]?.data}
        inProgress={inProgress}
        schemaType="Article"
      />
      <AboutCTAEnhancer />
      <ContactEnhancer />
    </>
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(
  withRouter,
  connect(mapStateToProps)
)(CMSPageComponent);

export default CMSPage;
